// extracted by mini-css-extract-plugin
export var header = "_vz-1";
export var maskBottom = "_vz-6";
export var maskMiddle = "_vz-7";
export var maskTop = "_vz-5";
export var root = "_vz-0";
export var scrollDownButton = "_vz-3";
export var scrollDownButtonHidden = "_vz-4";
export var viewport = "_vz-2";